import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  InputSignalWithTransform,
  signal,
  WritableSignal
} from '@angular/core';
import { PhonePipe } from '../../../../shared/pipes/phone.pipe';

@Component({
  selector: 'app-my-account-user',
  imports: [PhonePipe],
  templateUrl: './my-account-user.component.html',
  styleUrl: './my-account-user.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MyAccountUserComponent {
  protected readonly AVATAR_PLACEHOLDER: string =
    './assets/images/avatar-placeholder.png';

  avatar: InputSignalWithTransform<string, string> = input<string, string>(
    this.AVATAR_PLACEHOLDER,
    {
      transform: (value: string): string => {
        this._avatar.set(value);
        return value;
      }
    }
  );
  name: InputSignal<string> = input('');
  phone: InputSignal<string> = input('');

  _avatar: WritableSignal<string> = signal(this.AVATAR_PLACEHOLDER);

  onAvatarLoadError() {
    this._avatar.set(this.AVATAR_PLACEHOLDER);
  }
}
